import React, { Component } from 'react';
import './index.css';
import { message, Upload, Button, Modal, Table, Switch, UploadFile, Spin } from 'antd';
import { ExclamationCircleOutlined, LoadingOutlined, PlusOutlined,DeleteOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { 
    actionGetAdminInfo,
    actionAddAdmin,
    actionDeleteAdmin,
    actionUpdateInstitution,
} from '../../../../core/actions/silizhu/account';
import { 
    actionSetLoadingAnimation,
    actionCreateAdvertisement,
    actionDeleteAdvertisement,
    actionGetAdBoard,
    actionGetLoadingAnimation 
  } from '../../../../core/actions/silizhu/animation';
import { post, url } from '../../../../javascripts/http'
import { InstitutionService } from '../../../../api/sennotech/scanner/v2/institution'
import NewAdmin from './newAdmin'
import UpdateIns from './updateIns'
import UpMinute from './upMinute';
import ImgCrop from 'antd-img-crop'

interface StateProps {
    orgInfo,
    adminList: any[],
    animation: any;
    adBoard: any;
}

interface DispatchProps {
    getAdminInfo(): void,
    updateOrgInfo(data, file?): void
    addAdmin(data): void
    deleteAdmin(accountId): void
    setLoadingAnimation(file: File): void;
    createAdvertisement(file: File): void;
    deleteAdvertisement(adId: number): void;
    getAdBoard(): void;
    getLoadingAnimation(): void;
}

interface CustomUploadFile extends UploadFile {
    id: number;
    enabled: boolean;
    type?: string;
  }

  
const { confirm } = Modal;
const institutionService = new InstitutionService(url, post);
class Index extends Component<StateProps & DispatchProps> {
    
    state = {
        loading: false,
        imageUrl: '',
        visibleAdmin: false,
        visibleIns: false,
        visibleAd: false,
        confirmLoading: false,
        adLoading: false,
        animationLoading: false,
    }

    componentDidMount () {
        this.props.getAdminInfo();
        this.props.getAdBoard();
        this.props.getLoadingAnimation();
    }

    static getDerivedStateFromProps (props, state) {
        if(props.failData) {
            return {
                confirmLoading: false,
            }       
        }
        else if(props.isSuccess) {
            return {
                confirmLoading: false,
                visibleIns: false,
                visibleAdmin: false,
            }
        }
        return null;
    }

    Columns: any[] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        }, 
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name'
        }, 
        {
            title: '账号',
            render: (record) => {
                return <span>{record.mobileNumber || record.email}</span>
            }
        }, 
        {
            title: '权限',
            dataIndex: 'role',
            key: 'role',
            render: (text) => {
                switch(text) {
                    case "superAdmin": return "原始管理员";
                    case "admin":  return "管理员";
                    case "staff": return "店员";
                }
            }
        },
        
    ];

    ColumnsSuper = [
        ...this.Columns,
        {
            title: '操作',
            render : (record) => {
                if(record.role === 'superAdmin') {
                    return <span></span>
                }
                return (
                    <div>
                        <a onClick={() => this.onDeleteAdmin(record)}>删除</a>
                    </div>
                )
            }
        }
    ]


    beforeUpload = (file) => {
        const isPng = file.type === 'image/png' ;
        if(!isPng) {
            message.error('只支持png图片!');
        }
        else {
            const orgInfo = this.props.orgInfo;
            let data = {
                id: orgInfo.id,
                name: orgInfo.name,
                description: orgInfo.description,
                logo: orgInfo.logo,
            }
            this.props.updateOrgInfo(data, file);
        }
        return false;
        // const isLt2M = file.size / 1024 / 1024 < 2;
        // if(!isLt2M) {
        //     message.error('图片必须少于2MB!')
        // }
        // return isPng && isLt2M
    }

    getBase64(img, callBack) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callBack(reader.result));
        reader.readAsDataURL(img)
    }

    handleChange = info => {
        if(info.file.status === 'uploading') {
            this.setState({
                loading: true
            })
            return;
        }
        if(info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => {
                this.setState({
                    imageUrl,
                    loading: false
                })
            })
        }
    }

    onShowAdmin = () => {
        this.setState({
            visibleAdmin: true
        })
    }

    onAddAdmin = (formdata) => {
        console.log(formdata);
        this.props.addAdmin(formdata);
        this.setState({
            // confirmLoading: true
            visibleAdmin: false,
            confirmLoading: false,
        })
    }

    onCancelAdd = () => {
        this.setState({
            visibleAdmin: false,
            confirmLoading: false,
        })
    }

    showUpdateIns = () => {
        this.setState({
            visibleIns: true
        })
    }

    showUpdateAd = () => {
        this.setState({
            visibleAd: true
        })
    }

    onUpdateIns = (formdata) => {
        console.log(formdata);
        const orgInfo = this.props.orgInfo;
        let data = {
            id: orgInfo.id,
            name: formdata.name,
            description: orgInfo.description,
            logo: orgInfo.logo
        }
        this.props.updateOrgInfo(data);
        this.setState({
            // confirmLoading: true
            visibleIns: false,
            confirmLoading: false,
        })
    }

    onCancelUpdate = () => {
        this.setState({
            visibleIns: false,
            confirmLoading: false,
        })
    }

    onCancelAd = () => {
        this.setState({
            visibleAd: false,
            confirmLoading: false,
        })
    }

    onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
              const reader = new FileReader();
              reader.readAsDataURL(file.originFileObj);
              reader.onload = () => resolve(reader.result);
            });
          }
          const image = new Image();
          image.src = src;
          const imgWindow = window.open(src) as Window;
          imgWindow.document.write(image.outerHTML);
    }

    onDeleteAdmin = (item) => {
        const { deleteAdmin } = this.props;
        confirm({
            title: '确定删除管理员权限吗？',
            icon: <ExclamationCircleOutlined />,
            content: '删除后账号将不能登录后台',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                deleteAdmin(item.id)
            },
            onCancel() {

            }
        })
    }

    beforeAdUpload = (file: File) => {
        const isMedia = ['image/gif', 'video/mp4'].includes(file.type);
        if (!isMedia) {
        message.error('只支持GIF和MP4格式!');
        return Upload.LIST_IGNORE;
        }
        return true;
    }
    
    beforeAnimationUpload = (file: File) => {
        const isMedia = ['image/gif', 'video/mp4'].includes(file.type);
        if (!isMedia) {
        message.error('只支持GIF和MP4格式!');
        return Upload.LIST_IGNORE;
        }
        return true;
    }

    toggleAdStatus = async (adId: number, enabled: boolean) => {
        try {
          await institutionService.updateAdvertisement({
            id: adId,
            enabled
          });
          this.props.getAdBoard(); // 刷新广告列表
          message.success('状态更新成功',6);
        } catch (error) {
          message.error('状态更新失败',6);
        }
      }
      
    getAdFileList = (): CustomUploadFile[] => {
        const { adBoard } = this.props;
        if (!adBoard?.advertisements) return [];
        
        return adBoard.advertisements.map(ad => ({
          uid: ad.id.toString(),
          name: ad.resourceType,
          status: 'done',
          url: ad.resourceUrl,
          id: ad.id,
          enabled: ad.enabled,
          type: ad.resourceType,
        } as CustomUploadFile));
      }

      handleAdPreview = async (file: UploadFile) => {
        if (file.type?.includes('video')) {
          Modal.info({
            width: 800,
            title: '广告预览',
            content: (
              <video controls autoPlay muted loop playsInline style={{ width: '100%' }}>
                <source src={file.url}  />
              </video>
            ),
          });
        } else {
          Modal.info({
            title: '广告预览',
            width: 800,
            content: <img src={file.url} alt="广告预览" style={{ width: '100%' }} />,
          });
        }
      }
      
      handleAdRemove = (fileId) => {
        confirm({
          title: '确定删除这个广告吗？',
          icon: <ExclamationCircleOutlined />,
          onOk: async () => {
            try {
              this.setState({ adLoading: true });
              await this.props.deleteAdvertisement(fileId);
            } finally {
                this.props.getAdBoard();
              this.setState({ adLoading: false });
            }
          }
        });
        return false;
      }
      
      // 更新广告看板状态
      toggleAdBoardStatus = async(idleMinute) => {
        // const { orgInfo } = this.props;
        // institutionService.updateAdvertisementBoard({
        //   institutionId: orgInfo.id,
        //   idleMinute: idleMinute,
        // }).then(() => {
        //   this.props.getAdBoard();
        //   message.success('广告状态已更新',6);
        // }).catch((error) => {
        //   message.error('更新广告状态失败',6);
        // });
        try {
            const { orgInfo } = this.props;
            await institutionService.updateAdvertisementBoard({
                institutionId: orgInfo.id,
                idleMinute: idleMinute,
              })
            message.success('广告状态已更新',6);
        }
        catch (error) {
            message.error('更新广告状态失败',6);
        }
      }

    render() {
        const { loading, adLoading, animationLoading } = this.state;
        const uploadButton = (
            <div>
                {loading ? <LoadingOutlined /> : <PlusOutlined /> }
                <div style={{marginTop: 8}}>上传logo</div>
            </div>
        );
        const orgInfo = this.props.orgInfo || {};
        const imageUrl = orgInfo.logo || '';

        let adminList = this.props.adminList || [];
        let username = localStorage.getItem('username');
        let Columns = this.Columns;
        let superAdmin = adminList.find((item) => {
            return item.role === "superAdmin"
        }) || {};
        if(superAdmin.mobileNumber === username || superAdmin.email === username) {
            Columns = this.ColumnsSuper;
        }

        return (
            <div className="setting">
                {/* Spin在屏幕正中间 */}
                <Spin spinning={animationLoading||adLoading} size="large"  tip="正在上传..." style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }} />
                <div className="model">
                    <h3>机构信息</h3>
                    <ul>
                        <li>
                            <span>logo 设置</span>
                           <div>
                                {/* <ImgCrop 
                                    rotate 
                                    aspect={368/133}
                                    modalTitle="编辑logo"
                                    modalOk="确定"
                                    modalCancel="取消"
                                    > */}
                                    <Upload
                                        name="logo"
                                        listType="picture-card"
                                        className="logo-uploader-ins"
                                        showUploadList={false}
                                        action=''
                                        beforeUpload={this.beforeUpload}
                                        onChange={this.handleChange}
                                        onPreview={this.onPreview}
                                        >
                                        {imageUrl ? <img src={imageUrl} alt='logo' style={{ width: '100%'}} /> : uploadButton}
                                    </Upload>
                                {/* </ImgCrop> */}
                                <p className="tip">只支持.png格式, 推荐尺寸300*120</p>
                           </div>
                        </li>
                        <li>
                            <span>机构名称</span>
                            <span>
                                {orgInfo.name}
                                <a className="margin-left-20" onClick={() => this.showUpdateIns()}>修改</a>
                            </span>
                        </li>
                        <li>
                            <span>有效期</span>
                            <span>{orgInfo.validity}天</span>
                        </li>

                    </ul>
                </div>
                <div className="model">
                    <h3>动画和广告</h3>
                    <ul>
                        <li>
                        <span>加载动画设置</span>
                        <div className="switch">
                            <Upload
                            accept=".gif,.mp4"
                            beforeUpload={(file) => {
                                this.setState({ animationLoading: true });
                                return this.beforeAnimationUpload(file);
                              }}
                            customRequest={async ({ file }) => {
                            try {
                                await this.props.setLoadingAnimation(file as File);
                            } finally {
                                this.setState({ animationLoading: false });
                            }
                            }}
                            showUploadList={false}
                            maxCount={1}
                            disabled={animationLoading} 
                            >
                            {this.props.animation?.resourceUrl ? (
                                <div className="preview">
                                {this.props.animation.resourceType === 'video' ? (
                                    <video 
                                    src={this.props.animation.resourceUrl} 
                                    style={{ width: '220px' }}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    />
                                ) : (
                                    <img 
                                    src={this.props.animation.resourceUrl} 
                                    alt="加载动画" 
                                    style={{ width: '220px' }}
                                    />
                                )}
                                </div>
                            ):(
                                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',border: '1px dashed #d9d9d9', width: '220px', height: '220px' }}>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>上传动画</div>
                                </div>
                            )}
                            </Upload>
                            <p className="tip">支持GIF和视频, 推荐尺寸420*420</p>
                        </div>
                        </li>
                        <li> 
                            <span>广告闲置时间</span>
                            <span className="width-244">{this.props.adBoard?.idleMinute}分钟<a className="margin-left-20" onClick={() => this.showUpdateAd()}>修改</a></span>
                        </li>

                        <li>
                        <span>闲时广告设置</span>
                        <div className="ad-container">
                            <Upload<CustomUploadFile>
                            listType="picture-card"
                            accept=".gif,.mp4,.mov,.avi"
                            beforeUpload={(file) => {
                                this.setState({ adLoading: true });
                                return this.beforeAdUpload(file);
                              }}
                              customRequest={async ({ file, onSuccess }) => {
                                try {
                                  await this.props.createAdvertisement(file as File);
                                  onSuccess?.({});
                                }  finally {
                                    this.props.getAdBoard();
                                  this.setState({ adLoading: false });
                                }
                              }}
                            fileList={this.getAdFileList()}
                            itemRender={(originNode, file) => {
                                const customFile = file as CustomUploadFile;
                                return (
                                <div className="ad-item-wrapper" style={{ width: 100 }}> 
                                    {customFile.type === 'video' ? (
                                    <video
                                        src={customFile.url}
                                        onClick={() => this.handleAdPreview(customFile)}
                                        style={{ width: '100%', height: 120 }}
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                    />
                                    ) : (
                                    <img
                                        src={customFile.url}
                                        alt="广告"
                                        onClick={() => this.handleAdPreview(customFile)}
                                        style={{ width: '100%', height: 120, objectFit: 'cover' }}
                                    />
                                    )}
    
                                    <div className="ad-actions">
                                    <Switch
                                        checked={customFile.enabled}
                                        onChange={checked => this.toggleAdStatus(customFile.id, checked)}
                                        style={{ margin: '0 auto' }}
                                    />
                                    <DeleteOutlined 
                                        style={{ color: 'red', marginTop: 5, width: 30, height: 30 }} 
                                        onClick={() => this.handleAdRemove(customFile.id)}
                                        disabled={adLoading} 
                                    />
                                    </div>
                                </div>
                                );
                            }}
                            className="ad-upload-list"
                            disabled={adLoading} 
                            >
                            <div 
        
                            >
                                <PlusOutlined />
                                <div style={{ marginTop: 8 }}>上传广告</div>
                            </div>
                            </Upload>
                            <p className="tip">支持GIF和视频，推荐尺寸1920*1080</p>
                        </div>
                    
                        </li>
                    </ul>
                    </div>
                <div className="model">
                    <ul>
                        <li>
                            <span className="title">管理员设置</span>
                            <p>原始管理员账号不可删除 添加管理员可登录后台</p>
                        </li>
                        <li>
                            <span>管理员账号</span>
                            <span className="width-244">{superAdmin.mobileNumber || superAdmin.email}</span>
                            <Button 
                                type="primary" 
                                className="width-100" 
                                onClick={() => this.onShowAdmin()}
                                >添加</Button>
                        </li>
                        <Table 
                            rowKey={(record) => record.accountId}
                            dataSource={adminList} 
                            columns={Columns}
                            pagination={{
                                showSizeChanger: true,
                                defaultCurrent: 1,
                                total: adminList.length,
                                showTotal: total => `总 ${total} 条`
                            }}
                        />
                    </ul>
                </div>
                <NewAdmin 
                    failData=''
                    visible={this.state.visibleAdmin}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onAddAdmin}
                    onCancel={this.onCancelAdd}
                    />
                <UpdateIns 
                    data={orgInfo}
                    failData=''
                    visible={this.state.visibleIns}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.onUpdateIns}
                    onCancel={this.onCancelUpdate}
                    />
                <UpMinute
                    data={this.props.adBoard?.idleMinute}
                    visible={this.state.visibleAd}
                    confirmLoading={this.state.confirmLoading}
                    onCreate={this.toggleAdBoardStatus}
                    onCancel={this.onCancelAd}
                />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        orgInfo: state.user.orgInfo,
        adminList: state.silizhuAccount.adminList,
        animation: state.silizhuAnimation.animation,
        adBoard: state.silizhuAnimation.adBoard
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getAdminInfo: () => {
            dispatch(actionGetAdminInfo())
        },
        updateOrgInfo: (data, file?) => {
            dispatch(actionUpdateInstitution(data, file))
        },
        addAdmin: (data) => {
            dispatch(actionAddAdmin(data))
        },
        deleteAdmin: (accountId) => {
            dispatch(actionDeleteAdmin(accountId))
        },
        setLoadingAnimation: (file) => dispatch(actionSetLoadingAnimation(file)),
        createAdvertisement: (file) => dispatch(actionCreateAdvertisement(file)),
        deleteAdvertisement: (adId) => dispatch(actionDeleteAdvertisement(adId)),
        getLoadingAnimation: () => dispatch(actionGetLoadingAnimation()),
        getAdBoard: () => dispatch(actionGetAdBoard()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)